// Reusable Fieldlink Platform Map — the "one job, one system" module map.
// Only lists functionality that exists in the product. Pass `highlight`
// (a category id) to emphasise the relevant stage on specialist pages.
import { Link } from "react-router-dom";

const CATEGORIES = [
  {
    id: "commercial", label: "Commercial", to: "/civil-estimating-software-nz",
    items: ["AI Plan Reader", "Takeoffs", "Rate Library", "Estimating", "Quotes", "Variations", "Progress Claims & Invoices", "Job Costing"],
  },
  {
    id: "projects", label: "Projects", to: "/job-management-nz",
    items: ["Jobs", "Crew Planner", "Dispatch", "Site Diaries", "Documents", "Communications"],
  },
  {
    id: "field", label: "Field", to: "/timesheet-app-nz",
    items: ["Today's Work", "Timesheets", "Photos", "Running Sheets & Dockets", "Plans", "QR Site Sign-in"],
  },
  {
    id: "safety", label: "Safety + Quality", to: "/safety-management-nz",
    items: ["SSSPs", "Pre-Starts", "Toolbox Talks", "Hazards & Incidents", "QA Records & Forms", "Competencies"],
  },
  {
    id: "plant", label: "Plant + Fleet", to: "/fleet-management-nz",
    items: ["Fleet Register", "Machine Pre-Starts", "Damage Reports", "Servicing & WoF/CoF", "Fuel", "Live Tracking"],
  },
  {
    id: "people", label: "People", to: "/payroll-software-civil-nz",
    items: ["Workers & Teams", "Leave", "Payroll & Xero Export", "Fieldworker App", "Crew Chat"],
  },
];

export function PlatformMap({ highlight }) {
  return (
    <section className="bg-[#e9eeec] border-y border-[#cbd3d5] text-[#142635]" data-testid="platform-map">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="label-tag !text-[#a63c0b] mb-3">/ The Fieldlink platform</div>
        <h2 className="font-display font-black uppercase tracking-tight text-3xl sm:text-4xl leading-tight">
          One job. <span className="text-[#a63c0b]">One system.</span>
        </h2>
        <p className="text-[#52616c] mt-3 max-w-2xl text-sm md:text-base">
          Fieldlink isn't just a timesheet app — it connects the whole civil workflow, from the
          plan and the price to the crew, the plant and the final invoice.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
          {CATEGORIES.map((c) => {
            const hot = highlight === c.id;
            return (
              <Link key={c.id} to={c.to} data-testid={`platform-map-${c.id}`}
                className={`block border-2 p-5 transition-colors group ${hot ? "border-[#FF5F15] bg-[#FF5F15]/10" : "border-[#cbd3d5] hover:border-[#FF5F15]"}`}>
                <div className={`font-display font-black uppercase tracking-tight text-base mb-3 ${hot ? "text-[#a63c0b]" : "text-[#142635] group-hover:text-[#a63c0b]"} transition-colors`}>
                  {c.label}
                </div>
                <ul className="space-y-1.5">
                  {c.items.map((it) => (
                    <li key={it} className="text-xs text-[#52616c] flex items-start gap-2">
                      <span className={`mt-1.5 w-1 h-1 shrink-0 ${hot ? "bg-[#FF5F15]" : "bg-zinc-600"}`} />
                      {it}
                    </li>
                  ))}
                </ul>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
